import fieldsBuildMixin from "@/components/common/mini-table/mixins/fields-build-mixin";
import rowFilterMixin from "@/components/common/mini-table/mixins/row-filter-mixin";

export default {
    mixins: [fieldsBuildMixin, rowFilterMixin],
    props: {
        saveHolder: Object,
        effectOriginRow: {
            type: Boolean,
            default: false
        },
        editDataWithFields: String,
        enableInlineEdit: {
            type: Boolean,
            default: false
        },
        useInlineDeleteBtn: [Boolean, Function],
    },
    data() {
        return {
            fieldsMap: {},//props:fields->Map()
            focused: {
                index: -1,
                key: null
            },
            needDeleteIds: [],
        }
    },
    mounted() {
        document.addEventListener('keydown', this.whenKeyDown);
    },
    beforeDestroy() {
        document.removeEventListener('keydown', this.whenKeyDown);
    },
    methods: {
        columnEditData(force = false) {
            return this.finalColumnEditData(this.rowList, force);
        },
        finalColumnEditData(list = this.finalRowList, force = false) {
            let tempList = [];
            // if (this.frozenRows) {
            //     list = this.frozenRows;
            //     console.log('now frozen')
            // }
            for (let row of list) {
                let temp = {};
                let hasEdit = false;
                if (row[this.rowKey]) {
                    temp[this.rowKey] = row[this.rowKey];
                }
                if (this.saveHolder) {
                    hasEdit = true;
                    for (let item in this.saveHolder) {
                        if (this.saveHolder.hasOwnProperty(item)) {
                            temp[item] = this.saveHolder[item];
                        }
                    }
                }
                for (let field of this.localFields) {
                    if (field.isInput || row.__rowEditing) {
                        temp[field.key] = row[field.key];
                        if (!this.isFieldNameEditDisable(field.key, row)) {
                            hasEdit = true;
                        }
                    }
                }
                for (let field of this.editInvisibleFields) {
                    temp[field.key] = row[field.key];
                    hasEdit = true;
                }
                if (this.editDataWithFields) {
                    let fields = this.editDataWithFields.split(",");
                    for (let f of fields) {
                        temp[f] = row[f];
                        hasEdit = true;
                    }
                }
                if (force || hasEdit) {
                    tempList.push(temp);
                }
            }
            return tempList;
        },
        fieldIsEdit(data) {
            if (data.field.isInput) {
                return !this.isFieldNameEditDisable(data.field.key, data.item);
            }
            return data.item.__rowEditing;
        },
        isFieldNameEditDisable(fieldName, row) {
            let item = this.getOriginField(fieldName)
            return this.isFieldEditDisable(item, row);
        },
        isFieldEditDisable(field, row) {
            if (field && field.disableWhen) {
                return field.disableWhen(row);
            }
            return false;
        },
        isFiledEditView(data) {
            return data.field.type === 'checkbox';
        },
        getOriginField(key) {
            let temp = this.fieldsMap[key];
            if (temp) {
                return temp;
            }
            return null;
        },

        doSetWhenChange(field, val, rowIndex) {
            if (field.hasOwnProperty('setWhenChange')) {
                let temp = field.setWhenChange(val);
                if (temp != null && temp instanceof Object) {
                    for (let key in temp) {
                        this.finalRowList[rowIndex][key] = temp[key];
                    }
                }
            }
        },
        whenEditValueChange(cellData, newVal) {
            let rowIndex = cellData.index;
            for (let item of this.fields) {
                if (item.hasOwnProperty('changeByRow')) {
                    let val = item.changeByRow(this.finalRowList[rowIndex]);
                    this.finalRowList[rowIndex][item.key] = val;
                    this.doSetWhenChange(item, val, rowIndex);
                } else if (item.key === cellData.field.key) {
                    this.doSetWhenChange(item, newVal, rowIndex);
                }
            }
            this.$forceUpdate();
        },
        getDIRef(data) {
            return this.getDIRefWithKey(data.field.key, data.index);
        },
        getDIRefWithKey(key, index) {
            return `DI-${key}-${index}`;
        },
        getDiverseInputConfig(data) {
            let temp = this.deepCopy(data.field);
            temp.type = this.mutativeFieldType(data);
            return temp;
        },
        isInputCompete() {
            if (this.filterable && this.isFiltered()) {
                return false;
            }
            for (let i = 0; i < this.rowList.length; i++) {
                let row = this.rowList[i];
                for (let field of this.fields) {
                    if (field.isInput || row.__rowEditing) {
                        if (!this.isFieldEditDisable(field, row)) {
                            let temp = this.getDIRefEl(field.key, i);
                            if (temp && !temp.isValidated()) {
                                return false;
                            } else {
                                console.log('no temp');
                            }
                        }
                    }
                }
            }
            return true;
        },
        getDIRefEl(key, index) {
            return this.getRefEl(this.getDIRefWithKey(key, index));
        },
        whenInputFocus(data) {
            if (data) {
                this.focused.index = data.index;
                this.focused.key = data.field.key;
            }
        },
        whenKeyDown(event) {
            if (event) {
                if (event.code === 'KeyD' && (event.metaKey || event.ctrlKey)) {
                    this.duplicateCellValue();
                    event.preventDefault();
                }
                if (event.code === 'ArrowUp') {
                    this.focusPre();
                    event.preventDefault();
                }
                if (event.code === 'ArrowDown') {
                    this.focusNext();
                    event.preventDefault();
                }
            }
        },
        duplicateCellValue() {
            let index = this.focused.index;
            let lastIndex = this.finalRowList.length - 1;
            if (index >= 0 && index < lastIndex) {
                let value = this.finalRowList[index][this.focused.key];
                if (this.hasCode(value)) {
                    let field = this.getOriginField(this.focused.key)
                    if (field.isInput) {
                        while (index < lastIndex && (this.finalRowList[index + 1]._isGroupTag
                            || this.isFieldEditDisable(field, this.finalRowList[index + 1]))) {
                            index++;
                        }
                        if (index < lastIndex) {
                            this.finalRowList[index + 1][this.focused.key] = value;
                            let el = this.getDIRefEl(this.focused.key, index + 1);
                            if (el) {
                                el.focus();
                            }
                        }
                    }
                }
            }
        },
        focusPre() {
            let index = this.focused.index;
            if (index > 0) {
                let field = this.getOriginField(this.focused.key)
                if (field.isInput) {
                    while (index > 0 && (this.finalRowList[index - 1]._isGroupTag
                        || this.isFieldEditDisable(field, this.finalRowList[index - 1]))) {
                        index--;
                    }
                    if (index > 0) {
                        let el = this.getDIRefEl(this.focused.key, index - 1);
                        if (el) {
                            el.focus();
                        }
                    }
                } else if (this.finalRowList[index].__rowEditing) {
                    while (index > 0 && !this.finalRowList[index - 1].__rowEditing) {
                        index++;
                    }
                    if (index > 0) {
                        let el = this.getDIRefEl(this.focused.key, index - 1);
                        if (el) {
                            el.focus();
                        }
                    }
                }
            }
        },
        focusNext() {
            let index = this.focused.index;
            let lastIndex = this.finalRowList.length - 1;
            if (index >= 0 && index < lastIndex) {
                let field = this.getOriginField(this.focused.key)
                if (field.isInput) {
                    while (index < lastIndex && (this.finalRowList[index + 1]._isGroupTag
                        || this.isFieldEditDisable(field, this.finalRowList[index + 1]))) {
                        index++;
                    }
                    if (index < lastIndex) {
                        let el = this.getDIRefEl(this.focused.key, index + 1);
                        if (el) {
                            el.focus();
                        }
                    }
                } else if (this.finalRowList[index].__rowEditing) {
                    while (index < lastIndex && !this.finalRowList[index + 1].__rowEditing) {
                        index++;
                    }
                    if (index < lastIndex) {
                        let el = this.getDIRefEl(this.focused.key, index + 1);
                        if (el) {
                            el.focus();
                        }
                    }
                }
            }
        },

        setFieldsMap() {
            if (this.fields !== undefined) {
                let tempMap = {};
                for (let temp of this.fields) {
                    tempMap[temp.key] = temp;
                }
                this.fieldsMap = tempMap;
            }
        },

        addInlineNewRow() {
            this.rowList.splice(0, 0, {
                __rowEditing: true
            })
        },
        removeRow(index) {
            console.log(index)
            let row = this.rowList[index - 1];
            if (!row || row._index !== index) {
                row = null;
                for (let i = 0; i < this.rowList.length; i++) {
                    let item = this.rowList[i];
                    if (item._index === index) {
                        row = item;
                        index = i;
                        break;
                    }
                }
            } else {
                index -= 1;
            }
            if (row) {
                console.log(row);
                if (row[this.rowKey]) {
                    this.needDeleteIds.push(row[this.rowKey]);
                }
                this.rowList.splice(index, 1);
            }
        },
        editInlineRow(index) {
            this.$set(this.rowList[index], '__rowEditing', true);
        },
        cancelEditInlineRow(index) {
            this.$delete(this.rowList[index], '__rowEditing');
        },

        clearRowEdit() {
            this.needDeleteIds = [];
        },

        collectInlineEditData() {
            return {
                deleteIds: this.needDeleteIds,
                editRows: this.columnEditData()
            }
        },

        hasDIEdit() {
            let els = document.getElementsByClassName("mini-table-di-input-cover");
            return els && els.length > 0;
        },

        inlineDeleteBtnUsed(row) {
            if (this.useInlineDeleteBtn) {
                if (this.useInlineDeleteBtn instanceof Function) {
                    return this.useInlineDeleteBtn(row);
                }
                return this.useInlineDeleteBtn;
            }
            return false;
        },
    }
}
